export default __webpack_public_path__ + "static/media/Defiapp.12a2e9a8.png";